import { render, staticRenderFns } from "./AddSectionComponent.vue?vue&type=template&id=c472a980&"
import script from "./AddSectionComponent.vue?vue&type=script&lang=js&"
export * from "./AddSectionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports